import { FormValidator, ValidationResult } from '../formField/types/form-validator';
import { ObjectType } from '../../../configurationProfilesApp/exclusionItemGrid/types';
import { ExclusionItem, getObjectTypeModuleValues, Module } from '../../../configurationProfilesApp/exclusionsPanel/types';
import { containsWildcards, validateExcludedItem } from '../../../utils/globalExclusions/exclusionsValidationsUtils';
import { isEmpty } from '@nirvana/shared/basic-types/object';
import { translateFn } from '../../../utils/translator.helper';

export const wildcardSupportForModulesByTypes = {
  [ObjectType.FOLDER]: {
    [Module.RANSOMWARE_MITIGATION]: false,
  },
};

export const ExclusionValidator: (objectType: ObjectType, errorMessage: string) => FormValidator = (
  objectType: ObjectType,
  errorMessage: string
) => {
  return async (value: string): Promise<ValidationResult> => {
    if (validateExcludedItem(objectType, value)) {
      return { valid: true };
    }

    return { valid: false, error: errorMessage };
  };
};

export const ExclusionItemWildcardValidator: (exclusionItem: ExclusionItem, errorMessage: string) => FormValidator = (exclusionItem: ExclusionItem, errorMessage: string) => {
  return async (value: string): Promise<ValidationResult> => {
    exclusionItem.path = value;
    return checkThatExclusionWithWildcardAreSupported(exclusionItem);
  };
};

export function checkThatExclusionWithWildcardAreSupported(exclusionItem: ExclusionItem): ValidationResult {
  if (!containsWildcards(exclusionItem.path)) {
    return {valid: true};
  }

  let errorMessage = "";

  const modulesThatDoNotSupportWildcard = getModulesThatDoNotSupportWildcard(exclusionItem);
  if (containsWildcards(exclusionItem.path) && isEmpty(modulesThatDoNotSupportWildcard)) {
    return {valid: true};
  }

  const modules = getObjectTypeModuleValues(exclusionItem.type);
  const moduleLabels: Array<string> = [];
  modules.forEach((module) => {
    if (modulesThatDoNotSupportWildcard.indexOf(module.value) !== -1) {
      moduleLabels.push(module.label);
    }
  });
  errorMessage = translateFn("Wildcards are not supported in the following modules: {MODULES}", {MODULES: moduleLabels.join(", ")});
  return {
    valid: false,
    error: errorMessage,
  };
}


function getModulesThatDoNotSupportWildcard(exclusionItem: ExclusionItem): Array<number> {
  const wildcardSupportForModules: Record<number, boolean> = wildcardSupportForModulesByTypes[exclusionItem.type as number];

  if (!wildcardSupportForModules) {
    return [];
  }

  const modulesThatDoNotSupportWildcard: Array<number> = [];
  for (const module of exclusionItem.modules) {
    if (typeof wildcardSupportForModules[module] === 'boolean' && !wildcardSupportForModules[module]) {
      modulesThatDoNotSupportWildcard.push(module);
    }
  }

  return modulesThatDoNotSupportWildcard;
}
